import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import { string, ref } from "yup";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Icons
import { BiMinusCircle } from "react-icons/bi";
//Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
import { CREATE_CATEGORY } from "../../Schema/Category";
export default function CreateCategory({ open, handleClose, setRefetch }) {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createCategory] = useMutation(CREATE_CATEGORY, {
    onCompleted: ({ createCategory }) => {
      // console.log("createCategory",createCategory);

      setLoading(false);
      if (createCategory?.status) {
        setAlert(true, "success", createCategory?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createCategory?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    categoryEnName: Yup.string().required("ទាមទារ!"),
    categoryKhName: Yup.string().required("ទាមទារ!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      categoryEnName: "",
      categoryKhName: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      // console.log("createCategory-values:::", values);
      setLoading(true);
      createCategory({
        variables: {
          input: {
            ...values,
          },
        },
      });
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">បង្កើតប្រភេទ</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={6}>
                <Typography className="field-title">
                  ប្រភេទជាភាសាខ្មែរ
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ប្រភេទជាភាសាខ្មែរ"
                  {...getFieldProps("categoryKhName")}
                  error={Boolean(
                    touched.categoryKhName && errors.categoryKhName
                  )}
                  helperText={touched.categoryKhName && errors.categoryKhName}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="field-title">
                  ប្រភេទជាអង់គ្លេស
                </Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  size="small"
                  placeholder="ប្រភេទជាអង់គ្លេស"
                  {...getFieldProps("categoryEnName")}
                  error={Boolean(
                    touched.categoryEnName && errors.categoryEnName
                  )}
                  helperText={touched.categoryEnName && errors.categoryEnName}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className="field-title">ចំណាំ</Typography>
                <TextField
                  rows={3}
                  fullWidth
                  multiline
                  size="small"
                  placeholder="ចំណាំ"
                  className="text-field"
                  {...getFieldProps("remark")}
                  error={Boolean(touched.remark && errors.remark)}
                  helperText={touched.remark && errors.remark}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className="btn-create" fullWidth>
                    កំពុងដំណើរការ...
                  </Button>
                ) : (
                  <Button
                    className="btn-create"
                    fullWidth
                    onClick={handleSubmit}
                  >
                    បង្កើត
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
